import { useRef } from "react";
import {
	AlertDialog,
	AlertDialogBody,
	AlertDialogContent,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogOverlay,
	Text,
} from "@chakra-ui/react";

export interface DeleteTemplateDialogProps {
	isOpen: boolean;
	isDeleting: boolean;
	onCancel: () => void;
	onConfirm: () => void;
}

export const DeleteTemplateDialog: React.FC<DeleteTemplateDialogProps> = ({
	isOpen,
	isDeleting,
	onCancel,
	onConfirm,
}) => {
	const cancelRef = useRef<HTMLButtonElement>(null);

	return (
		<AlertDialog
			isOpen={isOpen}
			leastDestructiveRef={cancelRef}
			onClose={onCancel}
		>
			<AlertDialogOverlay>
				<AlertDialogContent>
					<AlertDialogHeader fontSize="lg" fontWeight="bold">
						Delete Template
					</AlertDialogHeader>
					<AlertDialogBody>
						<Text>
							This will permanently delete this quote template. This action
							cannot be undone.
						</Text>
					</AlertDialogBody>
					<AlertDialogFooter>
						<button
							ref={cancelRef}
							onClick={onCancel}
							className="rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
							type="button"
						>
							Cancel
						</button>
						<button
							onClick={onConfirm}
							disabled={isDeleting}
							className="ml-3 rounded-md bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700 disabled:opacity-50"
							type="button"
							data-testid="confirm-delete-template"
						>
							{isDeleting ? "Deleting..." : "Delete"}
						</button>
					</AlertDialogFooter>
				</AlertDialogContent>
			</AlertDialogOverlay>
		</AlertDialog>
	);
};
